import React, { useState } from 'react';
import { showError, showSuccess } from 'utils';
import styles from './index.module.scss';
import { cancelAndRefundOrder } from 'services';
import ItemRefundReasonDropdown from './ItemRefundReasonDropdown';
import { Loading } from 'components/loading/Loading';

const FullRefundModal = props => {
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedReason, setSelectedReson] = useState<string>('');
  const { orderId, onSuccess, toggleModal } = props;

  const refundOrder = async () => {
    setLoading(true);
    try {
      await cancelAndRefundOrder(orderId, selectedReason);
      showSuccess('Order Refunded and Cancelled successfully');
      onSuccess();
      toggleModal();
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  const renderRefundableItems = () => {
    return (
      <div className={styles['items-section']}>
        <div className={styles['item-detail-group']}>
          <div className={styles['label']}>Reason</div>
          <ItemRefundReasonDropdown
            isFull={true}
            value={selectedReason}
            className={'form-control'}
            onChange={setSelectedReson}
          />
        </div>
      </div>
    );
  };

  return (
    <div className={styles['main-container']}>
      {loading && <Loading/>}
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['modal-title']}>{`Refund and Cancel - ${orderId}`}</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          {renderRefundableItems()}
        </div>
        <div className={styles['modal-footer']}>
          <button
            className={styles['cancel-button']}
            onClick={toggleModal}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            onClick={refundOrder}
            className={styles['submit-button']}
            disabled={loading}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default FullRefundModal;
